








import Vue from "vue";
import store from "../store";

import FilteredContent from "@/components/FilteredContent.vue";
import PassageFilters from "@/components/PassageFilters.vue";

export default Vue.extend({
	name      : "Passage",
	components: {
		FilteredContent,
		PassageFilters,
	},
	beforeRouteEnter(to, from, next) {
		store.dispatch('changeFilterOptions', {
			numberOfParagraphs: Number(to.params.numberOfParagraphs),
		})
			.then(() => {
				store.dispatch("makePassage")
					.then(() => {
						next();
					})
					.catch((error) => {
						next(error);
					});
			})
			.catch((error) => {
				next(error);
			});
	},
	beforeRouteUpdate(to, from, next) {
		store.dispatch('changeFilterOptions', {
			numberOfParagraphs: Number(to.params.numberOfParagraphs),
		})
			.then(() => {
				store.dispatch("makePassage")
					.then(() => {
						next();
					})
					.catch((error) => {
						next(error);
					});
			})
			.catch((error) => {
				next(error);
			});
	},
});
